import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (visible()) {
      <div class="fixed inset-0 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md z-50 flex items-center justify-center">
        <div class="text-center">
          <!-- Logo central -->
          <div class="relative w-64 sm:w-80 h-28 mx-auto mb-6">
            <div class="absolute inset-0"></div>
            <div class="relative w-full h-full flex items-center justify-center">
              <img 
                [src]="logoSrc()" 
                [alt]="logoAlt()" 
                class="w-full h-full object-contain"
                width="320" height="112"
              />
            </div>
          </div>
          
          <!-- Spinner debajo del logo -->
          <div class="relative w-16 h-16 mx-auto mb-4">
            <div class="absolute inset-0 border-4 border-primary-200 dark:border-primary-800 rounded-full"></div>
            <div class="absolute inset-0 border-4 border-transparent border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin"></div>
          </div>
          
          <!-- Título y subtítulo -->
          <h3 class="text-md font-bold text-primary-800 dark:text-primary-400 mb-2">{{ title() }}</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">{{ subtitle() }}</p>
        </div>
      </div>
    }
  `,
  styles: []
})
export class LoadingOverlayComponent {
  visible = input<boolean>(false);
  title = input<string>('Cargando');
  subtitle = input<string>('Por favor espere...');
  logoSrc = input<string>('assets/images/logos/TRANSMARTIME-LOGO-BLANCO.png');
  logoAlt = input<string>('Transmaritime Inc.');
}
